export enum Validity {
  VALID,
  INVALID,
  UNCHECKED,
}

export type PasswordRequirements = {
  username: Validity;
  firstName: Validity;
  lastName: Validity;
  blockedWords: Validity;
  symbol: Validity;
  uppercase: Validity;
  lowercase: Validity;
  number: Validity;
  length: Validity;
};

export type PasswordValidation = {
  valid: Validity;
  requirements: PasswordRequirements;
};

export enum PasswordErrorType {
  REPEAT_PASSWORD,
  STRENGTH,
  OTHER,
}

export type PasswordSubmitResponse = {
  success: boolean;
  error: PasswordErrorType | null;
};

export type ValidateTokenResponse = {
  success: boolean;
  new_reset_token: string;
  web_session_id: string;
};
